import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import AdminLayout from './Layout/AdminLayout';
import AuthRoutes from './components/Auth/AuthRoutes';

const App = () => {
  const themeMode = useSelector((state) => state.themeMode?.themeMode);
  const themeColor = useSelector((state) => state.theme?.themeColor);
  const borderStroke = useSelector((state) => state.stroke?.borderStroke);
  const boxLayout = useSelector((state) => state.boxLayout?.boxLayout);
  const monochrome = useSelector((state) => state.monochrome?.monochrome);
  const borderRadius = useSelector((state) => state.borderRadius?.borderRadius);
  const iconColor = useSelector((state) => state.iconColor?.iconColor);
  const gradientColor = useSelector((state) => state.gradientColor?.gradientColor);
  const isAuthenticated = useSelector(state => state.auth?.isAuthenticated);
  const role = useSelector((state) => state.auth?.user?.role); 

  const location = useLocation();
  const pathname = location.pathname;

  if (!isAuthenticated) {
    return <AuthRoutes />;
  }

  return  (
    <AdminLayout
      themeMode={themeMode}
      themeColor={themeColor}
      borderStroke={borderStroke}
      boxLayout={boxLayout}
      monochrome={monochrome}
      borderRadius={borderRadius}
      iconColor={iconColor}
      gradientColor={gradientColor}
    />
  )
};

export default App;